export const NETWORK_STATUS = 'NETWORK_STATUS';
